import React, { useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { getSelectedGroupId } from 'ducks/products';
import Pill from 'ui/Pill/Pill';
import sortingIcon from '@ingka/ssr-icon/paths/sort-descending';
import ListBox from '@ingka/list-box';
import { usePlannerConfig } from 'contexts/plannerConfig';
import useClickOutside from 'hooks/useClickOutside';
import SkapaTooltip from 'ui/Tooltip/SkapaTooltip';
import SortingList from '../menus/Sorting';
import { reportToggleSorting } from 'analytics/reporters';

const SortingButton = () => {
  const {
    plannerConfig: { productGroups }
  } = usePlannerConfig();

  const { formatMessage } = useIntl();
  const selectedGroupId = useSelector(getSelectedGroupId);
  const [expanded, setExpanded] = useState<boolean>(false);
  const listRef = useRef<HTMLUListElement>(null);
  const pillRef = useRef<HTMLButtonElement>(null);

  const selectedGroup = productGroups.find(({ id }) => id === selectedGroupId);
  const hideAndReport = () => {
    setExpanded(prev => {
      prev && reportToggleSorting({ groupId: selectedGroupId, open: false });
      return false;
    });
  };

  useClickOutside([listRef, pillRef], hideAndReport);

  const toggle = () => {
    setExpanded(prev => {
      reportToggleSorting({ groupId: selectedGroupId, open: !prev });
      return !prev;
    });
  };

  if (!selectedGroup) return null;

  return (
    <ListBox
      position="left"
      open={expanded}
      trigger={
        <SkapaTooltip
          tooltipText={formatMessage({ id: 'storageone.sortingLabel' })}
          position="top"
          interactiveCustomTrigger
        >
          <Pill
            ref={pillRef}
            iconOnly
            selected={expanded}
            label={formatMessage({ id: 'storageone.sortingLabel' })}
            iconPosition="trailing"
            ssrIcon={sortingIcon}
            onClick={toggle}
          />
        </SkapaTooltip>
      }
    >
      <SortingList ref={listRef} onClick={hideAndReport} />
    </ListBox>
  );
};

export default SortingButton;
